module.exports = __webpack_public_path__ + "assets/img/head4-en.511cbfec.png";